module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail/modal-send-adjustment/modal-send-adjustment.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail/modal-send-adjustment/modal-send-adjustment.component.sass
// module chunks = main